// NotesTabContent.js
// Reusable content component for My Notes, Group Notes, and All Notes tabs

import React from "react";
import { FieldNoteFilterMenu } from "./FieldNoteFilterMenu";
import { FieldNoteList } from "./FieldNoteList";
import { GroupTabs } from "./GroupTabs";
import styles from "../FieldNotesTab.module.css";

export const NotesTabContent = ({
  // Tab configuration
  title,
  activeTab,
  // Notes data
  notes,
  // User info for edit permissions
  user,
  // UI state
  isFilterMenuOpen,
  filters,
  // Group-specific props (only for groupNotes tab)
  groups,
  activeGroupId,
  // Filter menu data
  employees,
  // Actions
  onToggleFilter,
  onApplyFilters,
  onResetFilters,
  onAddNote,
  onEditNote,
  onDeleteNote,
  onSetActiveGroupId,
}) => {
  // Determine if the current user can edit a note
  const canEditNote = (note) => note.employeeId === user?.employee_id;

  return (
    <div className={styles.tabContent}>
      {/* Header with title and action buttons */}
      <div className={styles.tabHeader}>
        <h4>{title}</h4>
        <div className={styles.headerActions}>
          <button className={styles.filterButton} onClick={onToggleFilter}>
            Filter
          </button>
          <button className={styles.addNoteButton} onClick={onAddNote}>
            Add Note
          </button>
        </div>
      </div>

      {/* Group Tabs - only shown for groupNotes tab */}
      {activeTab === "groupNotes" && (
        <GroupTabs
          groups={groups}
          activeGroupId={activeGroupId}
          setActiveGroupId={onSetActiveGroupId}
        />
      )}

      {/* Filter Menu */}
      {isFilterMenuOpen && (
        <FieldNoteFilterMenu
          filters={filters}
          applyFilters={onApplyFilters}
          resetFilters={onResetFilters}
          closeMenu={onToggleFilter}
          activeTab={activeTab}
          employees={employees || []}
          groups={groups || []}
        />
      )}

      {/* Notes List */}
      <FieldNoteList
        notes={notes}
        canEdit={canEditNote}
        onEdit={onEditNote}
        onDelete={onDeleteNote}
      />
    </div>
  );
};
